import { useQuery, useMutation } from "@tanstack/react-query";
import { submitAnalysis, getAnalysisJob, getScore, getPortfolioScores, getScoreTrend } from "@/api/analysis";

export function useSubmitAnalysis() {
  return useMutation({
    mutationFn: (cnpj: string) => submitAnalysis(cnpj),
  });
}

export function useAnalysisJob(jobId: number | null) {
  return useQuery({
    queryKey: ["analysis-job", jobId],
    queryFn: () => getAnalysisJob(jobId!),
    enabled: jobId !== null && jobId > 0,
    refetchInterval: (query) => {
      const status = query.state.data?.job?.status;
      if (status === "completed" || status === "failed" || status === "partial") return false;
      return 3000; // Poll every 3s while running
    },
  });
}

export function useScore(companyId: number) {
  return useQuery({
    queryKey: ["score", companyId],
    queryFn: () => getScore(companyId),
    enabled: companyId > 0,
    staleTime: 300_000, // 5 min
  });
}

export function usePortfolioScores() {
  return useQuery({
    queryKey: ["portfolio-scores"],
    queryFn: () => getPortfolioScores(),
    staleTime: 30_000,
  });
}

export function useScoreTrend(companyId: number, period = "30d") {
  return useQuery({
    queryKey: ["score-trend", companyId, period],
    queryFn: () => getScoreTrend(companyId, period),
    enabled: companyId > 0,
  });
}
